import getEventPath from "./getEventPath";
import isIe11 from "./isIe11";
export default {
  getEventPath,
  isIe11
};
//# sourceMappingURL=index.js.map